module.exports = __webpack_public_path__ + "assets/img/list_1.2cf701ae.svg";